import { PushSettings } from "./PushSettings";

export default PushSettings;
